import { IonIcon } from "@ionic/react";
import { chevronForward, settingsOutline } from "ionicons/icons";
import "./UpdateProfileSettings.css";
import { Link } from "react-router-dom";
export const UpdateProfileSettings = () => {
  return (
    <Link to="/settings" className="update-profile-settings">
      <div className="update-profile-settings-left">
        <IonIcon icon={settingsOutline} />
        <p>Settings</p>
      </div>
      <div className="update-profile-settings-right">
        <IonIcon
          className="update-profile-settings-icon"
          icon={chevronForward}
        />
      </div>
    </Link>
  );
};
